class RecoveryAccountLoginUsersController {
  static controller($scope) {
    'ngInject';
    $scope.resourceLogin = function(loginForm) {

      if(loginForm.password.$modelValue !== '1234') {
        loginForm.password.$setValidity('valid', false);
      } else {
        loginForm.password.$setValidity('valid', true);
        alert("OK! tu nastąpi przejście do wnętrza systemu");
      }
    }
  }
}

export default RecoveryAccountLoginUsersController.controller;



// WEBPACK FOOTER //
// ./src/users/forgot-password/recovery-account-login.users.controller.js